import { useApiQuery } from '../useApiQuery';
import { leadKeys } from '@/lib/queryKeys';
import { leadEndpoints } from '@/lib/api/endpoints';
import { apiGet, operationsClient } from '@/lib/api';
import type { LeadStage } from '@/types/lead';

export function useLeadStages() {
  return useApiQuery<LeadStage[]>({
    queryKey: leadKeys.stages(),
    queryFn: () => apiGet<LeadStage[]>(operationsClient, leadEndpoints.stages()),
    showErrorToast: false,
  });
}
